import { useEffect } from "react";

/**
 * ── 변경사항 (ECHO 톤) ──
 * MUI Switch (파란색) → ECHO 민트 토글 + 설명 문구
 */
const ReadingSelection = ({ selectedTypes, setSelectedTypes }) => {
  const hideTranslation = selectedTypes.find(
    (item) => item.key === "reading"
  )?.hide_translation;

  const readOnly = setSelectedTypes === undefined;

  const handleHideTranslationChange = (value) => {
    setSelectedTypes((prev) =>
      prev.map((item) =>
        item.key === "reading" ? { ...item, hide_translation: value } : item
      )
    );
  };

  useEffect(() => {
    handleHideTranslationChange(true);
    // eslint-disable-next-line
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "11px 14px",
        backgroundColor: "#F4F8F7",
        borderRadius: "12px",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "0.86rem",
            fontWeight: 800,
            color: "#0E141B",
            letterSpacing: "-0.01em",
          }}
        >
          해석 숨기기
        </div>
        <div style={{ fontSize: "0.74rem", color: "#7A8490", marginTop: "1px" }}>
          {hideTranslation
            ? "학생에게 한글 해석이 보이지 않습니다"
            : "학생이 한글 해석을 함께 볼 수 있습니다"}
        </div>
      </div>
      <div
        onClick={() => !readOnly && handleHideTranslationChange(!hideTranslation)}
        style={{
          width: "46px",
          height: "27px",
          borderRadius: "999px",
          backgroundColor: hideTranslation ? "#00D9C0" : "#D6DEE0",
          position: "relative",
          cursor: readOnly ? "default" : "pointer",
          transition: "background-color .15s",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "3px",
            left: hideTranslation ? "22px" : "3px",
            width: "21px",
            height: "21px",
            borderRadius: "50%",
            backgroundColor: "#FFF",
            boxShadow: "0 1px 3px rgba(14,20,27,.18)",
            transition: "left .15s",
          }}
        />
      </div>
    </div>
  );
};

export default ReadingSelection;
